import { Component, Emit, Inject, Model, Prop, Provide, Vue, Watch } from 'vue-property-decorator';
import config from '../../../api/params.config';
import PersonalList from '@/components/list-personal.vue';
// 声明变量
// declare const a: any;

@Component({
    components: {
        PersonalList,
    },
})
export default class ManagerList extends Vue {
    private $api: any;
    private $cookie: any;
    private model: any;
    private PersonShow: boolean = false;
    // 判断显示哪个列表页
    private IsNone: boolean = false;
    private MangerShow: boolean = false;
    private loading: boolean = true;
    private finished: boolean = false;
    private showSelect: boolean = false;
    private show: boolean = false;
    private isSelect: boolean = false;
    // 确认部门考勤按钮，根据权限控制它的显隐
    private ShowSurebtn: boolean = false;
    private active: number = 2;
    private minDate = new Date(2000, 1, 1);
    private maxDate = new Date(2030, 1, 1);
    private currentDate = new Date();
    private month: string = '';
    private state: string = '状态';
    private stateNum: any = null;
    private states: any = [{ state: '已处理' }, { state: '已反馈' }, { state: '已确认' }, { state: '未确认' }, { state: '全部' }];
    private message: string = '';
    private NowdataList: any = [];
    private onLoadNum: number = -1;
    private dataList: any = [];
    // 当前年份
    private currentYear: number | undefined;
    // 上月
    private prevMonth: number | undefined;
    private async created() {
        // 判断跨年后为上一年的最后一月
        if (this.currentDate.getMonth() === 0) {
            this.currentYear = this.currentDate.getFullYear() - 1;
            this.prevMonth = 12;
        } else {
            this.currentYear = this.currentDate.getFullYear();
            this.prevMonth = this.currentDate.getMonth();
        }
        this.$toast.loading({
            duration: 0,       // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            loadingType: 'spinner',
            message: '正在加载...',
        });
        // 判断身份显示哪个列表页，确认部门考勤的显隐
        const TimeModel = {
            year: this.currentYear,
            month: this.prevMonth,
        };
        const IsBtn = await this.$api.httpPost('membership/Monthlysummary/IPostBtnIsShow', TimeModel);
        if (IsBtn.Success && IsBtn.Data) {
            this.$toast.clear();
            if (IsBtn.Data.IsDepartRole) {
                this.MangerShow = true;
                this.PersonShow = false;
                // 查询数据
                this.queryData();
                // 控制月份的显示 MM
                if (this.prevMonth >= 1 && this.prevMonth < 10) {
                    this.month = '0' + this.prevMonth;
                } else {
                    this.month = this.prevMonth + '';
                }
            } else {
                this.PersonShow = true;
                this.MangerShow = false;
            }
            if (IsBtn.Data.IsDepartRole && IsBtn.Data.IsShowDepartCofirm) {
                this.ShowSurebtn = true;
            } else {
                this.ShowSurebtn = false;
            }
        } else {
            this.$toast.clear();
            this.$dialog.alert({
                title: '错误',
                message: IsBtn.AllMessages,
            });
        }
    }
    // 渲染列表数据
    private async queryData() {
        this.$toast.loading({
            duration: 0,       // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            loadingType: 'spinner',
            message: '正在加载...',
        });
        this.model = {
            Year: this.currentYear,
            Month: this.prevMonth,
            CheckStatus: null,
        };
        const model = this.model;
        const data = await this.$api.httpPost('membership/Monthlysummary/PostMonthlysummaryUserInfo', model);
        if (data.Success) {
            this.$toast.clear();
            if (data.Data && data.Data.length > 0) {
                this.IsNone = false;
                this.NowdataList = data.Data;
                if (this.NowdataList && this.NowdataList.length > 0) {
                    this.loading = false;
                } else {
                    this.loading = false;
                    this.finished = true;
                }
            } else {
                this.IsNone = true;
            }
        } else {
            this.$toast.clear();
            this.$dialog.alert({
                title: '错误',
                message: data.AllMessages,
            });
        }
    }
    // 默认加载10条数据，下拉加载更多
    private onLoad() {
        // 数据全部加载完成
        if (this.dataList.length === this.NowdataList.length) {
            // 加载状态结束
            this.loading = false;
            this.finished = true;
        } else {
            this.loading = false;
            this.onLoadNum += 1;
            this.dataList = this.dataList.concat(this.NowdataList.slice((this.onLoadNum) * 10, (this.onLoadNum + 1) * 10));
        }
    }

    // 月份、状态的显示
    private showpopup(type: string) {
        if (type === 'showSelect') {
            if (!this.showSelect) {
                this.showSelect = true;
            } else {
                this.showSelect = false;
            }
        } else if (type === 'showpopup') {
            if (!this.show) {
                this.show = true;
            } else {
                this.show = false;
            }
        }
    }

    // 日期的选择和取消
    private async confirm() {
        this.show = false;
        this.$toast.loading({
            duration: 0,       // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            loadingType: 'spinner',
            message: '正在加载...',
        });
        // 设置月份显示格式 YY-MM
        if ((this.currentDate.getMonth() + 1) >= 1 && (this.currentDate.getMonth() + 1) <= 9) {
            this.month = '0' + (this.currentDate.getMonth() + 1);
            this.currentYear = this.currentDate.getFullYear();
        } else {
            this.month = (this.currentDate.getMonth() + 1) + '';
            this.currentYear = this.currentDate.getFullYear();
        }
        // 获取到年月，传值给接口更新列表
        this.model = {
            Year: this.currentDate.getFullYear(),
            Month: this.currentDate.getMonth() + 1,
            CheckStatus: this.stateNum,
        };
        const model = this.model;
        const data = await this.$api.httpPost('membership/Monthlysummary/PostMonthlysummaryUserInfo', model);
        this.$toast.clear();
        if (data.Success) {
            this.onLoadNum = -1;
            this.dataList.length = 0;
            if (data.Data.length && data.Data.length > 0) {
                this.IsNone = false;
                this.NowdataList = data.Data;
                // 初始数据
                this.finished = false;
                this.onLoad();
            } else {
                this.IsNone = true;
            }
        } else {
            this.$dialog.alert({
                title: '错误',
                message: data.AllMessages,
            });
        }
        // 判断身份显示哪个列表页，确认部门考勤的显隐
        const TimeModel = {
            year: this.currentDate.getFullYear(),
            month: this.currentDate.getMonth() + 1,
        };
        const IsBtn = await this.$api.httpPost('membership/Monthlysummary/IPostBtnIsShow', TimeModel);
        // console.log(IsBtn);
        if (IsBtn.Success) {
            this.$toast.clear();
            if (IsBtn.Data) {
                if (IsBtn.Data.IsDepartRole && IsBtn.Data.IsShowDepartCofirm) {
                    this.ShowSurebtn = true;
                } else {
                    this.ShowSurebtn = false;
                }
            }
        } else {
            this.$toast.clear();
            this.$dialog.alert({
                title: '错误',
                message: IsBtn.AllMessages,
            });
        }
    }
    private cancel() {
        this.show = false;
    }
    private formatter(type: string, value: any) {
        if (type === 'year') {
            return `${value}年`;
        } else if (type === 'month') {
            return `${value}月`;
        }
        return value;
    }

    // 根据状态查询列表
    private async selectState(state: any) {
        this.$toast.loading({
            duration: 0,       // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            loadingType: 'spinner',
            message: '正在加载...',
        });
        if (state === '未确认') {
            this.stateNum = 0;
        } else if (state === '已反馈') {
            this.stateNum = 1;
        } else if (state === '已处理') {
            this.stateNum = 2;
        } else if (state === '已确认') {
            this.stateNum = 3;
        } else if (state === '全部') {
            this.stateNum = null;
        }
        this.state = state;
        this.showSelect = false;
        this.model = {
            Year: this.currentYear,
            Month: this.month,
            CheckStatus: this.stateNum,
        };
        const model = this.model;
        const data = await this.$api.httpPost('membership/Monthlysummary/PostMonthlysummaryUserInfo', model);
        this.$toast.clear();
        if (data.Success) {
            this.onLoadNum = -1;
            this.dataList.length = 0;
            if (data.Data.length && data.Data.length > 0) {
                this.IsNone = false;
                this.NowdataList = data.Data;
                // 初始数据
                this.finished = false;
                this.onLoad();
            } else {
                this.IsNone = true;
            }
        } else {
            this.$dialog.alert({
                title: '错误',
                message: data.AllMessages,
            });
        }
    }

    // 确认部门考勤
    private async sure() {
        this.$toast.loading({
            duration: 0,       // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            loadingType: 'spinner',
            message: '正在加载...',
        });
        // 先根据接口确定内容，message赋值
        const data = await this.$api.httpPost('membership/Monthlysummary/IPostDepartPeopleSubAttendance');
        if (data.Success) {
            this.$toast.clear();
            if (data.Data) {
                this.message = data.Data;
            } else {
                this.message = '点击确定，即确认您的部门员工本月考勤数据，是否确认？';
            }
        } else {
            this.$toast.clear();
            this.$dialog.alert({
                title: '错误',
                message: data.AllMessages,
            });
        }
        // this.ShowManagerProblem = true;
        this.$dialog.confirm({
            title: '确认部门考勤',
            message: this.message,
        }).then(() => {
            this.$api.httpPost('membership/Monthlysummary/IPostMonthlysummaryDepartconfirm');
            this.ShowSurebtn = false;
        }).catch(() => {
            // console.log('cancel');
        });
    }

    // 点击跳转详情页
    private async showInfo(item: any) {
        this.$router.push({ name: 'info-personal', query: { CId: item } });
    }
}
